import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    titleWithPermission: (workspaceCount: number, workspaceLimit: number) => string | React.ReactNode;
    titleNoPermission: string;
    detailsNoPermissionAdobe: string;
    detailsNoPermission: (ownerEmail: string) => string | React.ReactNode;
    detailsWithPermission: () => string | React.ReactNode;
};
export type Deps = {
    UniversalLink: any;
    SupportButton: any;
};
export default {
    DEFINE(_messages: Text, { UniversalLink, SupportButton }: Deps): void {
        return Object.defineProperties(this, {
            /** Title for billing managers */
            titleWithPermission: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (workspaceCount: number, workspaceLimit: number) => __intl__.intl().formatMessage({ id: "WorkspaceAlertBanner.titleWithPermission?c=1xe4kg10d4vxo", defaultMessage: "Workspace Limit Exceeded ({workspaceCount} of {workspaceLimit} Workspaces)" }, { workspaceCount: workspaceCount, workspaceLimit: workspaceLimit }));
                },
                enumerable: true,
                configurable: true
            },
            /** Title for non-billing users */
            titleNoPermission: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspaceAlertBanner.titleNoPermission?c=658jvbhlkowy", defaultMessage: "Workspace Limit Exceeded" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Message for Adobe-managed accounts without billing permissions */
            detailsNoPermissionAdobe: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspaceAlertBanner.detailsNoPermissionAdobe?c=1c4sxknq7xt21", defaultMessage: "Contact your admin for assistance." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Message for non-Adobe accounts without billing permissions */
            detailsNoPermission: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (ownerEmail: string) => __intl__.intl().formatMessage({ id: "WorkspaceAlertBanner.detailsNoPermission?c=14rsqfdn54qmj", defaultMessage: "<jsx>Contact account owner  <UniversalLink>({ownerEmail})</UniversalLink>  for assistance.</jsx>" }, { jsx: (__children__: React.ReactNode) => React.Children.toArray(__children__), UniversalLink: (__children__: React.ReactNode) => <UniversalLink href={`mailto:${ownerEmail}`} target="_blank">{React.Children.toArray(__children__)}</UniversalLink>, ownerEmail: ownerEmail }));
                },
                enumerable: true,
                configurable: true
            },
            /** Message for billing managers */
            detailsWithPermission: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => () => __intl__.intl().formatMessage({ id: "WorkspaceAlertBanner.detailsWithPermission?c=3toglqxh6nb1", defaultMessage: "<jsx><SupportButton>Contact support</SupportButton> for assistance.</jsx>" }, { jsx: (__children__: React.ReactNode) => React.Children.toArray(__children__), SupportButton: (__children__: React.ReactNode) => <SupportButton>{React.Children.toArray(__children__)}</SupportButton> }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps: Deps): void;
};
